export const SPAN_KINDS = [
  'session',
  'turn',
  'llm',
  'tts',
  'stt',
  'pronunciation',
  'voice',
  'tool_call',
  'agent_decision',
  'retrieval',
  'guardrail',
  'http',
  'db_query',
  'pipeline_stage',
  'module_step',
  'job',
  'composite',
] as const;

export type SpanKind = (typeof SPAN_KINDS)[number];

export function kindColor(kind: string): string {
  return `var(--k-${kind}, var(--text-tertiary))`;
}

export function isKnownKind(kind: string): kind is SpanKind {
  return (SPAN_KINDS as readonly string[]).includes(kind);
}
